<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Document Link</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <div class="text-wrap">
    <p><a target="_blank" [href]="folder_link.url">{{ folder_link.url }}</a></p>
  </div>

  <h6>Description</h6>
  <p>{{ folder_link.description }}</p>

  <ng-container *ngIf="folder_link.created_by_user">
    <h6>Created By</h6>
    <p>
      <a (click)="onUserPublicView(folder_link.created_by_user.hash)"
         matTooltip="View User Public Profile">
        {{ folder_link.created_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="folder_link.date_created">
    <h6>Created At</h6>
    <p>{{ (folder_link.date_created * 1000) | timezoneConvertLong}}</p>
  </ng-container>

  <ng-container *ngIf="folder_link.updated_by_user">
    <h6>Last Updated By</h6>
    <p>
      <a (click)="onUserPublicView(folder_link.updated_by_user.hash)"
         matTooltip="View User Public Profile">
        {{ folder_link.updated_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="folder_link.date_modified">
    <h6>Last Updated At</h6>
    <p>{{ (folder_link.date_modified * 1000) | timezoneConvertLong}}</p>
  </ng-container>

</mat-dialog-content>
